import { render, staticRenderFns } from "./List.vue?vue&type=template&id=452acea0&scoped=true&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452acea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452acea0')) {
      api.createRecord('452acea0', component.options)
    } else {
      api.reload('452acea0', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=452acea0&scoped=true&", function () {
      api.rerender('452acea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/List.vue"
export default component.exports